import script from "./ImportComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ImportComponent.vue?vue&type=style&index=0&id=48ad4150&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48ad4150"]])

export default __exports__